import React from 'react';
import clsx from 'clsx';

type LogoVariant = 'primary' | 'white' | 'icon';
type LogoSize = 'sm' | 'md' | 'lg';

interface ClassTechLogoProps {
  variant?: LogoVariant;
  size?: LogoSize;
  showTagline?: boolean;
  className?: string;
}

const sizeClasses: Record<LogoSize, string> = {
  sm: 'h-9',
  md: 'h-11',
  lg: 'h-14',
};

const ClassTechLogo: React.FC<ClassTechLogoProps> = ({
  variant = 'primary',
  size = 'md',
  showTagline = false,
  className,
}) => {
  const isWhite = variant === 'white';

  if (variant === 'icon') {
    return (
      <img
        src='/assets/class-tech-icon-ct.svg'
        alt='Class Tech'
        className={clsx(sizeClasses[size], 'w-auto shrink-0', className)}
      />
    );
  }

  return (
    <span className={clsx('inline-flex items-center gap-3', className)}>
      <img
        src={
          isWhite
            ? '/assets/class-tech-icon-white.svg'
            : '/assets/class-tech-icon-ct.svg'
        }
        alt=''
        aria-hidden='true'
        className={clsx(sizeClasses[size], 'w-auto shrink-0')}
      />
      <span className='leading-none'>
        <span className='block font-english text-xl font-bold tracking-normal'>
          <span className={isWhite ? 'text-white' : 'text-brand-navy dark:text-white'}>
            Class
          </span>
          <span className={isWhite ? 'text-white' : 'text-brand-primary dark:text-primary-400'}>
            {' '}
            Tech
          </span>
        </span>
        {showTagline ? (
          <span
            className={clsx(
              'mt-1 block text-xs font-semibold',
              isWhite ? 'text-white/75' : 'text-brand-text-secondary dark:text-secondary-300'
            )}
          >
            تعليم أذكى، إدارة أسهل
          </span>
        ) : null}
      </span>
    </span>
  );
};

export default ClassTechLogo;
